import type { ColDef } from "ag-grid-community";
import {
  idColumn,
  nameColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";

const columnDefs: ColDef[] = [idColumn, nameColumn, statusColumn, actionColumn];
export default columnDefs;
